<div class="body" id="body">
    <div class="row py-4">
        <div class="col-md-1 col-sm-1"></div>
        <div class="col-md-4 col-sm-12 titulo">
            <p><b>Parabéns! Você acaba de ser indicado por um amigo que deseja o melhor para o seu futuro.</b> Ele já
                faz parte do Plano Família. Faça parte você também. Deixe o seu contato que vamos apresentar o melhor
                investimento em previdência.</p>
        </div>
    </div>
    <div class="row py-4">
        <div class="col-md-1 col-sm-1"></div>
        <div class="col-md-6 col-sm-11 card">
            <form [formGroup]="formData" style="padding:0.25rem 0.25rem;" class="row">
                <div class="col-md-4 col-sm-12 py-1">
                    <label class="label-form">Nome completo <span class="label__form__required">*</span></label>
                    <input class="form-control input-form" formControlName="nome">
                    <small class="form-text text-muted danger ng-pristine"
                        *ngIf="formData.get('nome')?.touched && formData.get('nome')?.invalid">
                        O campo Nome completo é Obrigatório.
                    </small>
                </div>
                <div class="col-md-4 col-sm-12 py-1">
                    <label class="label-form">Telefone para contato <span class="label__form__required">*</span></label>
                    <input class="form-control input-form" placeholder="(DDD) 9XXXX-XXXX" formControlName="celular"
                        mask="(XX) XXXXX-XXXX">
                    <small class="form-text text-muted danger ng-pristine"
                        *ngIf="formData.get('celular')?.touched && formData.get('celular')?.invalid">
                        O campo Telefone é Obrigatório.
                    </small>
                </div>
                <div class="col-md-4 col-sm-12 py-1">
                    <label class="label-form">Endereço de Email <span class="label__form__required">*</span></label>
                    <input class="form-control input-form" formControlName="email" type="email">
                    <small class="form-text text-muted danger ng-pristine"
                        *ngIf="formData.get('email')?.touched && formData.get('email')?.invalid">
                        O campo Email é Obrigatório.
                    </small>
                </div>
                <div class="col-md-12 my-4" *ngIf="!completo">
                    <div class="float-right col-12 px-0">
                        <button type="button" class="btn btn-default col-xl-4" (click)="continue()"
                            [disabled]="formData.invalid">
                            Realizar Cadastro Completo
                        </button>
                        <button type="submit" class="btn btn-primary col-xl-2 float-right" (click)="save()"
                            [disabled]="formData.invalid">
                            Solicitar Contato
                        </button>
                    </div>
                </div>
            </form>
            <form [formGroup]="formCompleto" style="padding:0.25rem 0.25rem;" *ngIf="completo">
                <div class="row">
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Telefone Fixo</label>
                        <input class="form-control input-form" placeholder="(DDD) XXXX-XXXX" formControlName="telefone"
                            mask="(XX) XXXX-XXXX">
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Email Secundário</label>
                        <input class="form-control input-form" formControlName="email2" type="email2">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">CPF <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" placeholder="XXX.XXX.XXX-XX" formControlName="cpf"
                            mask="XXX.XXX.XXX-XX">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('cpf')?.touched && formCompleto.get('cpf')?.invalid">
                            O campo CPF é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Data de nascimento
                            <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" type="date" max="{{today | date:'yyyy-MM-dd'}}"
                            formControlName="dt_nascimento" (change)="calculaIdade()">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('dt_nascimento')?.touched && formCompleto.get('dt_nascimento')?.invalid">
                            Por favor, informe sua data de nascimento!
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Tipo de Documento <span class="label__form__required">*</span></label>
                        <ng-select [items]="tipoDocumentoList" bindLabel="desc" bindValue="desc"
                            formControlName="tipo_documento" appendTo="body">
                        </ng-select>
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('tipo_documento')?.touched && formCompleto.get('tipo_documento')?.invalid">
                            O campo Tipo de Documento é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Numero Documento <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="documento">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('documento')?.touched && formCompleto.get('documento')?.invalid">
                            O campo Numero do documento é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Órgão Expedidor <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="orgao_expedidor">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('orgao_expedidor')?.touched && formCompleto.get('orgao_expedidor')?.invalid">
                            O campo Orgão Expedidor é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Data Expedição <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" type="date" max="{{today | date:'yyyy-MM-dd'}}"
                            formControlName="dt_expedicao">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('dt_expedicao')?.touched && formCompleto.get('dt_expedicao')?.invalid">
                            O campo Data Expedição é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Nome do Pai</label>
                        <input class="form-control input-form" formControlName="nome_pai">
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Nome da Mãe <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="nome_mae">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('nome_mae')?.touched && formCompleto.get('nome_mae')?.invalid">
                            O campo Nome da Mãe é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Sexo <span class="label__form__required">*</span></label>
                        <ng-select [items]="sexoList" bindLabel="desc" bindValue="desc" formControlName="sexo"
                            appendTo="body">
                        </ng-select>
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('sexo')?.touched && formCompleto.get('sexo')?.invalid">
                            O campo Sexo é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Estado Civil <span class="label__form__required">*</span></label>
                        <ng-select [items]="estadoCivilList" bindLabel="desc" bindValue="desc"
                            formControlName="estado_civil" appendTo="body">
                        </ng-select>
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('estado_civil')?.touched && formCompleto.get('estado_civil')?.invalid">
                            O campo Estado Civil é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Profissão <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="profissao">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('profissao')?.touched && formCompleto.get('profissao')?.invalid">
                            O campo Profissao é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Valor da Renda <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="vl_renda" type="number">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('vl_renda')?.touched && formCompleto.get('vl_renda')?.invalid">
                            O campo Valor da Renda é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Nacionalidade <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="nacionalidade">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('nacionalidade')?.touched && formCompleto.get('nacionalidade')?.invalid">
                            O campo Nacionalidade é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Naturalidade <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="naturalidade">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('naturalidade')?.touched && formCompleto.get('naturalidade')?.invalid">
                            O campo Naturalidade é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Politicamente Exposto
                            <span class="label__form__required">*</span></label>
                        <ng-select [items]="simNaoList" bindLabel="desc" bindValue="desc"
                            formControlName="politicamente_exposto" appendTo="body">
                        </ng-select>
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('politicamente_exposto')?.touched && formCompleto.get('politicamente_exposto')?.invalid">
                            O campo Politicamente Exposto é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1" *ngIf="this.formCompleto.value.idade >= 16">
                        <label class="label-form">CPF Cônjuge</label>
                        <input class="form-control input-form" formControlName="cpf_conjuge">
                    </div>
                    <div class="col-md-4 col-sm-12 py-1" *ngIf="this.formCompleto.value.idade >= 16">
                        <label class="label-form">Nome Cônjuge</label>
                        <input class="form-control input-form" formControlName="nome_conjuge">
                    </div>
                    <div class="col-md-4 col-sm-12 py-1" *ngIf="this.formCompleto.value.idade < 18">
                        <label class="label-form">CPF Representante <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="cpf_representante">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('cpf_representante')?.touched && formCompleto.get('cpf_representante')?.invalid">
                            O campo CPF Representante é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1" *ngIf="this.formCompleto.value.idade < 18">
                        <label class="label-form">Nome Representante
                            <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="nome_representante">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('nome_representante')?.touched && formCompleto.get('nome_representante')?.invalid">
                            O campo Nome Representante é Obrigatório.
                        </small>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">CEP <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="cep" maxlength="9" mask="00000-000"
                            placeholder="XXXXX-XXX" (keyup)="cepChanged()">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('cep')?.touched && formCompleto.get('cep')?.invalid">
                            O campo CEP é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Endereço <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="endereco">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('endereco')?.touched && formCompleto.get('endereco')?.invalid">
                            O campo Endereço é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Número <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="numero" type="number">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('numero')?.touched && formCompleto.get('numero')?.invalid">
                            O campo Número é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Complemento</label>
                        <input class="form-control input-form" formControlName="complemento">
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Bairro <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="bairro">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('bairro')?.touched && formCompleto.get('bairro')?.invalid">
                            O campo Bairro é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Cidade <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="cidade">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('cidade')?.touched && formCompleto.get('cidade')?.invalid">
                            O campo Cidade é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Estado <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="estado">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('estado')?.touched && formCompleto.get('estado')?.invalid">
                            O campo Estado é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">País <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="pais">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('pais')?.touched && formCompleto.get('pais')?.invalid">
                            O campo País é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Usar este endereço para correspondências
                            <span class="label__form__required">*</span></label>
                        <ng-select [items]="simNaoList" bindLabel="desc" bindValue="desc"
                            formControlName="endereco_principal" appendTo="body">
                        </ng-select>
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('endereco_principal')?.touched && formCompleto.get('endereco_principal')?.invalid">
                            O campo é Obrigatório.
                        </small>
                    </div>
                </div>
                <div class="row" *ngIf="formCompleto.get('endereco_principal')?.value != 'Sim'">
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Tipo de Endereço
                            <span class="label__form__required">*</span></label>
                        <ng-select [items]="tipoEnderecoList" bindLabel="desc" bindValue="desc"
                            formControlName="tipo_endereco2" appendTo="body">
                        </ng-select>
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('tipo_endereco2')?.touched && formCompleto.get('tipo_endereco2')?.invalid">
                            O campo é Tipo de Endereço Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">CEP <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="cep2" maxlength="9" mask="00000-000"
                            placeholder="XXXXX-XXX" (keyup)="cep2Changed()">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('cep2')?.touched && formCompleto.get('cep2')?.invalid">
                            O campo CEP é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Endereço <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="endereco2">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('endereco2')?.touched && formCompleto.get('endereco2')?.invalid">
                            O campo Endereço é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Número <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="numero2" type="number">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('numero2')?.touched && formCompleto.get('numero2')?.invalid">
                            O campo Número é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Complemento</label>
                        <input class="form-control input-form" formControlName="complemento2">
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Bairro <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="bairro2">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('bairro2')?.touched && formCompleto.get('bairro2')?.invalid">
                            O campo Bairro é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Cidade <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="cidade2">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('cidade2')?.touched && formCompleto.get('cidade2')?.invalid">
                            O campo Cidade é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Estado <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="estado2">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('estado2')?.touched && formCompleto.get('estado2')?.invalid">
                            O campo Estado é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">País <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="pais2">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('pais2')?.touched && formCompleto.get('pais2')?.invalid">
                            O campo País é Obrigatório.
                        </small>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Tipo de Pagamento <span class="label__form__required">*</span></label>
                        <ng-select [items]="tipoPagamentoList" bindLabel="desc" bindValue="desc"
                            formControlName="tipo_pagamento" appendTo="body">
                        </ng-select>
                        <small class="form-text text-muted danger">
                            Desconto em Folha - apenas para funcionários da Fundação Copel</small>
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('tipo_pagamento')?.touched && formCompleto.get('tipo_pagamento')?.invalid">
                            O campo Tipo de Pagamento é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Dia do Vencimento <span class="label__form__required">*</span></label>
                        <ng-select [items]="diaVencimentoList" bindLabel="desc" bindValue="desc"
                            formControlName="dia_vencimento" appendTo="body">
                        </ng-select>
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('dia_vencimento')?.touched && formCompleto.get('dia_vencimento')?.invalid">
                            O campo Dia do Vencimento é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Idade para Aposentadoria
                            <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="idade_beneficio" type="number">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('idade_beneficio')?.touched && formCompleto.get('idade_beneficio')?.invalid">
                            O campo Idade para Aposentadoria é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Valor de Contribuicao
                            <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="vl_contribuicao" type="number">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('vl_contribuicao')?.touched && formCompleto.get('vl_contribuicao')?.invalid">
                            O campo Valor de Contribuicao é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Valor de Risco por Invalidez
                            <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="vl_risco_invalidez" type="number">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('vl_risco_invalidez')?.touched && formCompleto.get('vl_risco_invalidez')?.invalid">
                            O campo Valor de Risco por Invalidez é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Valor de Risco por Morte
                            <span class="label__form__required">*</span></label>
                        <input class="form-control input-form" formControlName="vl_risco_morte" type="number">
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('vl_risco_morte')?.touched && formCompleto.get('vl_risco_morte')?.invalid">
                            O campo Valor de Risco por Morte é Obrigatório.
                        </small>
                    </div>
                    <div class="col-md-4 col-sm-12 py-1">
                        <label class="label-form">Tipo de Tributação
                            <span class="label__form__required">*</span></label>
                        <ng-select [items]="tributacaoList" bindLabel="desc" bindValue="desc"
                            formControlName="tipo_tributacao" appendTo="body">
                        </ng-select>
                        <small class="form-text text-muted danger ng-pristine"
                            *ngIf="formCompleto.get('tipo_tributacao')?.touched && formCompleto.get('tipo_tributacao')?.invalid">
                            O campo Tipo de Tributação é Obrigatório.
                        </small>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 py-1">
                        <div class="px-0 col-12">
                            <form-input [isRequired]="true" [isMultiple]="true" [labelInput]="'Upload do documento '"
                                [tipoDocumento]="'financialInvoiceMedical'" (adicionar)="adicionarArquivos($event)">
                            </form-input>
                        </div>
                        <section class="col-xl-12 p-0 content-form-lista"
                            *ngIf="listaDocumentos && listaDocumentos.length > 0">
                            <div class="lista-row" *ngFor="let file of listaDocumentos; let i = index">
                                <span>
                                    {{file.fileName}}
                                </span>
                                <div class="lista-actions">
                                    <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                        (click)="removeFile(i)" [icon]="faSquareXmark">
                                    </fa-icon>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <div class="col-md-12 my-4">
                    <div class="float-right col-12 px-0">
                        <button type="submit" class="btn btn-primary col-xl-2 float-right" (click)="save()"
                            [disabled]="formCompleto.invalid">
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>